export default "__VITE_ASSET__C62ZVUqa__"